export const getOfferType = (discount = {}) => {
  if (discount.discountCode) return { name: 'Single Discount Code', key: 'discountCode' }
  if (discount.codePool) return { name: 'Code Pool', key: 'codePool' }
  if (discount.protectedLink) return { name: 'Protected Link', key: 'protectedLink' }
  return { name: '', key: 'none' }
}

const getDiscountDetails = (row) => {
  const offerType = getOfferType(row.discount)
  return {
    offerType,
    details: row.discount?.[offerType.key],
  }
}

const isCodeOffer = (offerType) => (
  offerType.key === 'discountCode' || offerType.key === 'codePool'
)

const getDiscountType = (row) => {
  const discountType = row.discount?.scheme?.typeName
  return discountType === 'NoScheme' || discountType === 'None' ? 'None' : discountType ?? ''
}

export const offerExportColumns = [
  { field: 'offer_id', valueGetter: ({ row }) => row.offerId },
  { field: 'offer_name', valueGetter: ({ row }) => row.name },
  { field: 'offer_status', valueGetter: ({ row }) => row.status ?? '' },
  { field: 'offer_type', valueGetter: ({ row }) => getOfferType(row.discount).name },
  { field: 'offer_link', valueGetter: ({ row }) => getDiscountDetails(row).details?.link ?? '' },
  { field: 'discount_type', valueGetter: ({ row }) => getDiscountType(row) },
  { field: 'discount_value', valueGetter: ({ row }) => row.discount?.scheme?.amount ?? '' },
  {
    field: 'single_discount_code',
    valueGetter: ({ row }) => (
      getOfferType(row.discount).key === 'discountCode' ? row.discount.discountCode.code ?? '' : ''
    ),
  },
  {
    field: 'code_pool_id',
    valueGetter: ({ row }) => (
      getOfferType(row.discount).key === 'codePool' ? row.discount.codePool.id ?? '' : ''
    ),
  },
  {
    field: 'discount_instructions',
    valueGetter: ({ row }) => {
      const { offerType, details } = getDiscountDetails(row)
      return isCodeOffer(offerType) ? details?.instructions ?? '' : ''
    },
  },
  {
    field: 'pass_code_in_url',
    valueGetter: ({ row }) => {
      const { offerType, details } = getDiscountDetails(row)
      return isCodeOffer(offerType) ? Boolean(details?.passCodeInUrl) : false
    },
  },
  {
    field: 'hide_code_on_offer_screen',
    valueGetter: ({ row }) => {
      const { offerType, details } = getDiscountDetails(row)
      return isCodeOffer(offerType) ? details?.showCodeInDisplay === false : false
    },
  },
  {
    field: 'parameter_name',
    valueGetter: ({ row }) => {
      const { offerType, details } = getDiscountDetails(row)
      return isCodeOffer(offerType) ? details?.urlParameterName ?? '' : ''
    },
  },
  { field: 'description', valueGetter: ({ row }) => row.description ?? '' },
  { field: 'commission_rate', valueGetter: ({ row }) => row.billingRules?.commissionRate ?? '' },
  {
    field: 'sales_channel_govx',
    valueGetter: ({ row }) => row.channels?.includes('GovXMarketplace') ?? false,
  },
  {
    field: 'sales_channel_offer_page',
    valueGetter: ({ row }) => row.channels?.includes('GovXMarketplaceOfferPage') ?? false,
  },
  {
    field: 'eligible_affiliation_us_military',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('UsMilitary') ?? false,
  },
  {
    field: 'eligible_affiliation_us_military_family',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('MilitaryFamily') ?? false,
  },
  {
    field: 'eligible_affiliation_law_enforcement',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('Police') ?? false,
  },
  {
    field: 'eligible_affiliation_fire',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('FirstResponder') ?? false,
  },
  {
    field: 'eligible_affiliation_medical_services',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('Medical') ?? false,
  },
  {
    field: 'eligible_affiliation_government_employee',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('Government') ?? false,
  },
  {
    field: 'eligible_affiliation_education',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('Education') ?? false,
  },
  {
    field: 'eligible_affiliation_vcs',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('Vcs') ?? false,
  },
  {
    field: 'eligible_affiliation_internal_user',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('InternalUser') ?? false,
  },
  {
    field: 'eligible_affiliation_student',
    valueGetter: ({ row }) => row.verification?.eligibleGroups?.includes('Student') ?? false,
  },
]
